import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MuiModal from '../../mui/MuiModal/MuiModal';
import { displayConfirm } from '../../redux/actions';
import Buttons, { ConfirmOption } from './buttons';

type ConfirmState = {
	active: boolean;
	props?: {
		title?: React.ReactNode;
		message?: React.ReactNode;
		options?: ConfirmOption[];
		defaultCallback?: () => void;
		closable?: boolean;
		zIndex?: number;
		dataCy?: string;
	} | null;
};

const Confirm: React.FC = () => {
	const confirm: ConfirmState | undefined = useSelector(
		( state: any ) => state.confirm
	);
	const dispatch = useDispatch();
	const cancel = useCallback(
		() => dispatch( displayConfirm( { active: false, props: null } ) ),
		[ dispatch ]
	);
	const defaultCallback = confirm?.props?.defaultCallback;
	const preventDisplay =
		typeof window !== 'undefined' &&
		window.localStorage.getItem( 'RockPaperCoinPreventConfirm' );

	useEffect( () => {
		if ( preventDisplay ) {
			cancel();
			defaultCallback?.();
		}
	}, [
		cancel,
		defaultCallback,
		preventDisplay
	] );

	if ( !confirm?.active ) return null;

	const {
		title,
		message,
		options,
		closable = true,
		zIndex = 11,
		dataCy,
	} = confirm.props || {};

	return (
		<MuiModal
			canClose={ closable }
			muiModalProps={ {
				open: true,
				onClose: cancel,
				slotProps: {
					paper: {
						id: 'confirm',
						...( dataCy ? { 'data-cy': dataCy } : {} ),
					},
				},
				sx: { zIndex },
			} }
			title={ title }
			description={ message }
			controls={ <Buttons options={ options } /> }
		/>
	);
};

export default Confirm;
